import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { AssignCommitmentRequest } from '@cast/types';

import { getCommitmentsAssignmentsListQueryKey } from 'hooks/queries/commitments/useAssignmentsQuery';
import { getCommitmentAssignmentsQueryKey } from 'hooks/queries/commitments/useCommitmentAssignmentsQuery';
import { getCommitmentsQueryKey } from 'hooks/queries/commitments/useCommitmentsQuery';

const assignCommitments = async (
  assignmentRequests: AssignCommitmentRequest[]
) => {
  return Promise.all(
    assignmentRequests.map(({ clusterId, commitmentId }) =>
      apiClient.commitments.assignCommitment({
        clusterId,
        commitmentId,
      })
    )
  );
};

export const useAssignCommitmentsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: assignCommitments,
    // invalidate cache regardless of success or error since partial failures are possible
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: getCommitmentsQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getCommitmentsAssignmentsListQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getCommitmentAssignmentsQueryKey(),
      });
    },
  });
};
